import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertTriangle } from 'lucide-react';
export function UrgencySection() {
  return <section className="px-6 py-10 max-w-3xl mx-auto" data-id="element-226">
      <FadeIn data-id="element-227">
        <div className="bg-[#9B4F2B]/10 border border-[#9B4F2B]/30 rounded-2xl p-6 md:p-8 mb-8 flex gap-4 items-start" data-id="element-228">
          <AlertTriangle className="text-[#9B4F2B] shrink-0 mt-1" size={28} data-id="element-229" />
          <div data-id="element-230">
            <p className="font-bold text-[#9B4F2B] text-lg mb-2" data-id="element-231">
              PRECIO DE LANZAMIENTO:
            </p>
            <p className="text-[#2D2A26] leading-relaxed" data-id="element-232">
              $6.39 USD es el precio de introducción. Una vez que esta ventana
              cierre, el precio sube a $17 USD y no habrá excepciones ni códigos
              especiales.
            </p>
          </div>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-center text-[#2D2A26] leading-relaxed" data-id="element-233">
          <p className="font-bold text-2xl mb-6" data-id="element-234">
            Pero hay algo más importante que el precio:
          </p>

          <p className="font-bold text-[#4A5D3A] text-xl md:text-2xl" data-id="element-235">
            Cada noche que pasa sin el protocolo correcto es otra noche que tu
            sistema nervioso se queda atascado en modo emergencia.
          </p>

          <div className="py-4 space-y-3 text-[#2D2A26]/80" data-id="element-236">
            <p data-id="element-237">Otro amanecer con presión en el pecho.</p>
            <p data-id="element-238">Otro día comenzando desde el déficit.</p>
            <p data-id="element-239">Otra versión de ti que se va quedando atrás.</p>
          </div>

          <p className="italic" data-id="element-240">
            El mejor momento para actuar fue hace seis meses.
          </p>

          <p className="font-bold text-2xl md:text-3xl text-[#9B4F2B] mt-6" data-id="element-241">
            El segundo mejor momento es ahora mismo.
          </p>
        </div>
      </FadeIn>
    </section>;
}